<template>
  <div>
    <div style="text-align: center">
      <h1>获客明细表</h1>
      <span>单位:笔</span>
    </div>

    <div
      style="
        display: flex;
        flex-direction: row;
        justify-content: center;
        margin-top: 20px;
      "
    >
      <div>
        <el-checkbox-group
          v-model="checkList"
          @change="handleCheckedCitiesChange"
        >
          <el-checkbox label="0" :disabled="disabled">时间区间</el-checkbox>
          <el-checkbox label="1" :disabled="disabled">商户名称</el-checkbox>
          <el-checkbox label="2" :disabled="disabled">商品id</el-checkbox>
          <el-checkbox label="3" :disabled="disabled">渠道来源</el-checkbox>
        </el-checkbox-group>
      </div>
      <div style="margin-left: 20px">
        <el-switch v-model="value" active-text="锁定" @change="switchChange">
        </el-switch>
      </div>
    </div>

    <div
      style="display: flex; flex: 0 1 50%; height: 100%; margin-top: 50px"
      v-if="bdInfo"
    >
      <div style="height: 100%; width: 100%"></div>

      <div
        style="
          height: 100%;
          width: 100%;
          display: flex;
          justify-content: center;
          align-items: center;
        "
      >
        <img
          src="../../../assets/img/jia.png"
          @click="chaxun()"
          style="cursor: pointer; width: 70px"
        />
      </div>
    </div>

    <div style="margin-top: 50px" v-else>
      <div
        style="
          height: 100%;
          width: 100%;
          display: flex;
          justify-content: center;
          align-items: center;
        "
      >
        <img
          src="../../../assets/img/jia.png"
          @click="chaxun()"
          style="cursor: pointer; width: 70px"
        />
      </div>
    </div>

    <el-dialog
      title="输入条件"
      :visible.sync="centerDialogVisible"
      width="30%"
      center
    >
      <div>
        <el-form
          size="small"
          :inline="true"
          :model="searchForm"
          class="demo-form-inline"
        >
          <el-form-item label="时间区间">
            <el-date-picker
              v-model="datePicker"
              type="datetimerange"
              :picker-options="pickerOptions"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              align="right"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item label="商户名称">
            <el-input
              v-model="searchForm.search"
              placeholder="请输入商户名称"
            ></el-input>
          </el-form-item>
          <el-form-item label="商品ID"
            ><el-input
              size="small"
              v-model="searchForm.order_no"
              placeholder="请输入商品ID"
            ></el-input
          ></el-form-item>
          <el-form-item label="渠道来源">
            <el-checkbox-group v-model="test">
              <el-checkbox label="0">演示租小程序</el-checkbox>
            </el-checkbox-group>
          </el-form-item>
        </el-form>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button @click="centerDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="queding()">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { formatDate } from "@/utils/DateTime.js";
export default {
  data() {
    let endDate = new Date();
    let startDate = new Date();
    startDate.setTime(startDate.getTime() - 3600 * 1000 * 24 * 1);
    return {
      checkList: [],
      value: false,
      disabled: false,
      bdInfo: "",
      centerDialogVisible: false,
      //时间
      pickerOptions: {
        shortcuts: [
          {
            text: "昨天",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 1);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "今天",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 0);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一年",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 365);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      datePicker: [
        formatDate(startDate, "yyyy-MM-dd 00:00:00"),
        formatDate(endDate, "yyyy-MM-dd 23:59:59"),
      ],
      // 搜索框
      searchForm: {
        search: "",
        order_no: "",
        remarks_operation: "",
      },
      test:""
    };
  },
  mounted() {},
  created() {},
  methods: {
    handleCheckedCitiesChange(value) {
      // console.log(value);
    },
    switchChange(value) {
      // console.log(value);
      this.disabled = !this.disabled;
      console.log(this.checkList);
      if (!this.disabled) {
        this.bdInfo = null;
      }
    },
    chaxun() {
      console.log("点击了");
      this.centerDialogVisible = true;
    },
    queding() {
      console.log("确定");
      this.centerDialogVisible = false;
      this.bdInfo = 1;
    },
  },
};
</script>

<style lang="scss" scoped>
</style>


// WEBPACK FOOTER //
// src/views/manage/data/index.vue